'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const styles = require('./DetailsReturnModal.scss');
const copy = require('../../../../../json/copy/buyerAssuranceTrade.json');
const get = require('lodash.get');
const Title = require('./ShippingDetailsModal/DetailsTitle');

function Note({ note, additionalNotesHeader }) {
    if (!note) {
        return null;
    }
    return (
        <span data-tn="return-modal-additional-notes" className={`colSm12 ${styles.returnPolicyLine}`}>
            {additionalNotesHeader}: {note}
        </span>
    );
}

Note.propTypes = {
    additionalNotesHeader: PropTypes.string,
    note: PropTypes.string
};

function ReturnPolicy({ returnPolicy, note, additionalNotesHeader }) {
    const text = Object.keys(returnPolicy).map(key => (
        <ReturnPolicyLine key={`returnsLine-${key}`} {...(returnPolicy[key])} />
    ));

    return (
        <div data-tn="return-modal-return-policy" className={`rowFlex colSm12 ${styles.returnPolicy}`}>
            {text}
            <Note note={note} additionalNotesHeader={additionalNotesHeader} />
        </div>
    );
}

ReturnPolicy.propTypes = {
    additionalNotesHeader: PropTypes.string,
    note: PropTypes.string,
    returnPolicy: PropTypes.object
};

function ReturnPolicyLine(props) {
    return (
        <span className={`colSm12 ${styles.returnPolicyLine}`}>
            {props.body}
            {props.link ? <a href={props.link}>{props.linkCTA}</a> : null}
        </span>
    );
}

ReturnPolicyLine.propTypes = {
    body: PropTypes.string.isRequired,
    link: PropTypes.string,
    linkCTA: PropTypes.string
};

function Guarantee() {
    return (
        <div className={`rowFlex colSm12 ${styles.guarantee}`}>
            <div className={`colSm12 ${styles.guaranteeLine}`}/>
            <span className={`colSm12 ${styles.guaranteeHeader}`}>
                {copy.buyerProtection.header}
            </span>
            <span className={`colSm12 ${styles.guaranteeText}`}>
                {copy.buyerProtection.beforeLink}
                <a href={copy.buyerProtection.linkHref}>{copy.buyerProtection.linkCTA}</a>
                {copy.buyerProtection.afterLink}
            </span>
        </div>
    );
}

function DetailsReturnModal({ user = {}, item = {}, closeModal = () => {} }) {
    // in cases where the user is not logged in, the explicit `null` passed in for GraphQL overrides the default
    // empty object assignment
    user = user || {};
    const itemReturnPolicy = get(item, 'returnPolicy.buyerCopy', {});
    const { canSeeTradeReturns } = user;
    const returnsAccepted = get(item, 'returnPolicy.accept');
    const note = get(item, 'returnPolicy.note');
    const additionalNotesHeader = get(item, 'returnPolicy.buyerCopy.additionalNotesHeader');

    let returnPolicy = Object.keys(itemReturnPolicy)
        // __dataID__ is internal to relay; additionalNotesHeader will be passed separately
        .filter(key => (key !== '__dataID__' && key !== 'additionalNotesHeader') && !!itemReturnPolicy[key])
        .reduce((obj, key) => Object.assign(obj, { [key]: { body: itemReturnPolicy[key] } }), {});

    if (canSeeTradeReturns && item.isTradeReturnAvailable) {
        if (returnsAccepted) {
            // Include the dealer's return policy and the trade return policy
            returnPolicy = Object.assign({}, returnPolicy, {
                tradeCopy: { body: copy.returnPolicyModal.returnsAccepted },
                responsibility: copy.tradeResponsibility
            });
        } else {
            // Do not include the dealer's return policy; include the trade return policy and the dealer responsibility
            // disclaimer block.
            returnPolicy = {
                tradeCopy: { body: copy.returnPolicyModal.returnsNotAccepted },
                responsibility: copy.tradeResponsibility
            };
        }
    }

    return (
        <div data-tn="return-details-modal" className={`containerFluid ${styles.wrapper}`}>
            <Title close={closeModal} title={copy.title} />
            <div className={styles.body}>
                <ReturnPolicy returnPolicy={returnPolicy} note={note} additionalNotesHeader={additionalNotesHeader} />
                <Guarantee />
            </div>
        </div>
    );
}

DetailsReturnModal.propTypes = {
    item: PropTypes.object,
    user: PropTypes.object,
    closeModal: PropTypes.func
};

module.exports = Relay.createContainer(DetailsReturnModal, {
    fragments: {
        item: () => Relay.QL`
            fragment on Item {
                isTradeReturnAvailable
                returnPolicy {
                    buyerCopy {
                        returnsAccepted
                        returnsNotAccepted
                        additionalNotesHeader
                        shippingResponsibility
                    }
                    accept
                    note
                }
            }
        `,
        user: () => Relay.QL`
            fragment on User {
                canSeeTradeReturns: hasPermission(name: "B_TRADE_RETURN_POLICY")
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsReturnModal.jsx